module.exports = __webpack_public_path__ + "img/leakalert_blink_blue.ca585805.jpg";